"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportToJsonFile = exports.trimSnippet = exports.getSrcFromHtml = void 0;

var setNewSizeParams = function setNewSizeParams(url, size) {
  var parser = document.createElement('a');
  parser.href = url;
  var query = parser.search.substring(1);
  var base = parser.href.split('?')[0];
  var vars = query.split('&');

  switch (size) {
    case 'sm':
      vars[0] = 'fit=250%2C150';
      var newTailS = vars[0] + '&' + vars[1];
      return base + '?' + newTailS;

    case 'lg':
      vars[0] = 'fit=450%2C350';
      var newTailL = vars[0] + '&' + vars[1];
      return base + '?' + newTailL;

    case 'xl':
      vars[0] = 'fit=675%2C525';
      var newTailXL = vars[0] + '&' + vars[1];
      return base + '?' + newTailXL;

    default:
      return url;
  }
};

var getSrcFromHtml = function getSrcFromHtml(htmlString) {
  var resize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var size = arguments.length > 2 ? arguments[2] : undefined;
  var tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;
  var htmlObject = tempDiv.firstChild;
  var srcTagFull = htmlObject.getAttribute('src');

  if (resize) {
    return setNewSizeParams(srcTagFull, size);
  }

  ;
  return srcTagFull;
};

exports.getSrcFromHtml = getSrcFromHtml;

var trimSnippet = function trimSnippet(snippet) {
  var res = snippet.split('Continue reading');
  return res[0];
};

exports.trimSnippet = trimSnippet;

var exportToJsonFile = function exportToJsonFile(jsonData, name) {
  var dataStr = JSON.stringify(jsonData);
  var dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
  var exportFileName = "".concat(name, ".json");
  var linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', exportFileName);
  linkElement.click();
};

exports.exportToJsonFile = exportToJsonFile;

//# sourceMappingURL=feed-toolz.js.map